import { Apollo } from 'apollo-angular';
import * as fromGraphQl from './graphql';
import { Tenant } from '../../entities/tenant/tenant';
import { Inject } from '@angular/core';
import { NXDataSourcePrime } from '../../services/dataSource/NXDataSourcePrime';

export class TenantDataSource extends NXDataSourcePrime<Tenant> {
  constructor(
    apollo: Apollo,
    @Inject('env') environment : any
    ) {
    super(apollo, fromGraphQl.TENANTS_QUERY, environment);
  }
  handleSubscriptionResult(data: fromGraphQl.TenantsQueryResponse): void {
    super.setSubject(
      data.tenants?.content ? data.tenants?.content : [],
      data.tenants?.totalElements ? data.tenants.totalElements : 0
    );
  }

  loadTenants(variables: any): void {
    this.querySubscription?.unsubscribe();
    this.subscribeToQuery(variables);
  }
}
